import { hashHistory } from 'react-router';
import queryString from 'query-string';

// Get 'app' path
import { path as CPM_PATH } from '../..';

// All paths
const PATHS = {
  CARPARKS: 'carparks',
  DASHBOARD: 'dashboard',
  SHOWCASE: 'showcase',
  INFORMATION: 'information',
  OLD_SETTINGS: 'old_settings',
  SETTINGS: 'settings',
  PLANNINGS: 'plannings',
  CONFIGURATION: 'configuration',
  PRICE_GRIDS: 'price_grids',
  EQUIPMENTS: 'equipments',
  CUSTOMERS: 'users',
  PARKINGS: 'access_rights',
  BOOKINGS: 'bookings',
  ONEPARK_BOOKINGS: 'onepark_bookings',
  ON_DEMANDS: 'on_demands',
  ON_DEMANDS_NEW: 'on_demands_new',
  ACCESSES: 'access_log',
  LOGIN: 'login',
  METRICS_ACCESS: 'metrics_access',
  METRICS_OCCUPANCY_RATE: 'metrics_occupancy_rate',
  METRICS_PREDICTED_OCCUPANCY_RATE: 'metrics_predicted_occupancy_rate',
  METRICS_REVENUE: 'metrics_revenue',
  INVOICES: 'invoices',
};

// Exported paths
export const MAIN_PATH = PATHS.CARPARKS;
export const DASHBOARD_PATH = PATHS.DASHBOARD;
export const SHOWCASE_PATH = PATHS.SHOWCASE;
export const INFORMATION_PATH = PATHS.INFORMATION;
export const SETTINGS_PATH = PATHS.SETTINGS;
export const OLD_SETTINGS_PATH = PATHS.OLD_SETTINGS;
export const PLANNINGS_PATH = PATHS.PLANNINGS;
export const PRICE_GRIDS_PATH = PATHS.PRICE_GRIDS;
export const EQUIPMENTS_PATH = PATHS.EQUIPMENTS;
export const CONFIGURATION_PATH = PATHS.CONFIGURATION;
export const CUSTOMERS_PATH = PATHS.CUSTOMERS;
export const PARKINGS_PATH = PATHS.PARKINGS;
export const BOOKINGS_PATH = PATHS.BOOKINGS;
export const ONEPARK_BOOKINGS_PATH = PATHS.ONEPARK_BOOKINGS;
export const ON_DEMANDS_PATH = PATHS.ON_DEMANDS;
export const ON_DEMANDS_NEW_PATH = PATHS.ON_DEMANDS_NEW;
export const ACCESSES_PATH = PATHS.ACCESSES;
export const { LOGIN } = PATHS;
export const METRICS_ACCESS_PATH = PATHS.METRICS_ACCESS;
export const METRICS_OCCUPANCY_RATE_PATH = PATHS.METRICS_OCCUPANCY_RATE;
export const METRICS_PREDICTED_OCCUPANCY_RATE_PATH = PATHS.METRICS_PREDICTED_OCCUPANCY_RATE;
export const METRICS_REVENUE_PATH = PATHS.METRICS_REVENUE;
export const INVOICES_PATH = PATHS.INVOICES;

// Root
const CPM_CARPARKS_PATH = `${CPM_PATH}/${MAIN_PATH}`;

export const listPath = (queryParams) => {
  const search = queryParams ? `?${queryString.stringify(queryParams, { encode: true })}` : '';
  return `${CPM_CARPARKS_PATH}${search}`;
};
export const navigateToList = (queryParams) => {
  hashHistory.push(listPath(queryParams));
};

export const showPath = (id) => `${CPM_CARPARKS_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};

// Login
export const loginPath = () => `${CPM_CARPARKS_PATH}/${LOGIN}`;
export const navigateToLogin = (id) => {
  hashHistory.push(loginPath(id));
};

// Dashboard
export const dashboardPath = (id) => `${showPath(id)}/${DASHBOARD_PATH}`;
export const navigateToDashboard = (id) => {
  hashHistory.push(dashboardPath(id));
};

// Information
export const informationPath = (id) => `${showPath(id)}/${INFORMATION_PATH}`;
export const navigateToInformation = (id) => {
  hashHistory.push(informationPath(id));
};

// Old Settings
export const oldSettingsPath = (id) => `${showPath(id)}/${OLD_SETTINGS_PATH}`;
export const navigateToOldSettings = (id) => {
  hashHistory.push(oldSettingsPath(id));
};

// Settings
export const settingsPath = (id) => `${showPath(id)}/${SETTINGS_PATH}`;
export const navigateToSettings = (id) => {
  hashHistory.push(settingsPath(id));
};

// Plannings
export const planningsPath = (id) => `${showPath(id)}/${PLANNINGS_PATH}`;
export const navigateToPlannings = (id) => {
  hashHistory.push(planningsPath(id));
};

// Configuration
export const configurationPath = (id) => `${showPath(id)}/${CONFIGURATION_PATH}`;
export const navigateToConfiguration = (id) => {
  hashHistory.push(configurationPath(id));
};

// Price grids
export const priceGridsPath = (id) => `${showPath(id)}/${PRICE_GRIDS_PATH}`;
export const navigateToPriceGrids = (id) => {
  hashHistory.push(priceGridsPath(id));
};

// Equipments
export const equipmentsPath = (id) => `${showPath(id)}/${EQUIPMENTS_PATH}`;
export const navigateToEquipments = (id) => {
  hashHistory.push(equipmentsPath(id));
};

// Customers
export const customersPath = (id) => `${showPath(id)}/${CUSTOMERS_PATH}`;
export const navigateToCustomers = (id, queryParams) => {
  const queryStringified = queryString.stringify(queryParams);
  const url = queryStringified ? `${customersPath(id)}?${queryStringified}` : customersPath(id);
  hashHistory.push(url);
};

// Parkings
export const parkingsPath = (id) => `${showPath(id)}/${PARKINGS_PATH}`;
export const navigateToParkings = (id) => {
  hashHistory.push(parkingsPath(id));
};

// Bookings
export const bookingsPath = (id) => `${showPath(id)}/${BOOKINGS_PATH}`;
export const navigateToBookings = (id, queryParams) => {
  const queryStringified = queryString.stringify(queryParams);
  const url = queryStringified ? `${bookingsPath(id)}?${queryStringified}` : bookingsPath(id);

  hashHistory.push(url);
};

// Onepark Bookings
export const oneparkBookingsPath = (id) => `${showPath(id)}/${ONEPARK_BOOKINGS_PATH}`;
export const navigateToOneparkBookings = (id) => {
  hashHistory.push(oneparkBookingsPath(id));
};

// Parkings
export const onDemandsPath = (id) => `${showPath(id)}/${ON_DEMANDS_PATH}`;
export const navigateToOnDemands = (id, queryParams) => {
  const queryStringified = queryString.stringify(queryParams);
  const url = queryStringified ? `${onDemandsPath(id)}?${queryStringified}` : onDemandsPath(id);

  hashHistory.push(url);
};

// Accesses
export const accessesPath = (id) => `${showPath(id)}/${ACCESSES_PATH}`;
export const navigateToAccesses = (id) => {
  hashHistory.push(accessesPath(id));
};

// Reports
export const metricsAccessPath = (id) => `${showPath(id)}/${METRICS_ACCESS_PATH}`;
export const navigateToMetricsAccess = (id) => {
  hashHistory.push(metricsAccessPath(id));
};

export const metricsOccupancyRatePath = (id) => `${showPath(id)}/${METRICS_OCCUPANCY_RATE_PATH}`;
export const navigateToMetricsOccupancyRate = (id) => {
  hashHistory.push(metricsOccupancyRatePath(id));
};

export const metricsPredictedOccupancyRatePath = (id) => `${showPath(id)}/${METRICS_PREDICTED_OCCUPANCY_RATE_PATH}`;
export const navigateToMetricsPredictedOccupancyRate = (id) => {
  hashHistory.push(metricsPredictedOccupancyRatePath(id));
};

export const metricsRevenuePath = (id) => `${showPath(id)}/${METRICS_REVENUE_PATH}`;
export const navigateToMetricsRevenue = (id) => {
  hashHistory.push(metricsRevenuePath(id));
};

export const invoicesPath = (id) => `${showPath(id)}/${INVOICES_PATH}`;
export const navigateToInvoices = (id) => {
  hashHistory.push(invoicesPath(id));
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/navigation.js